/* A photo from the phone's camera, in a type the sync can send. The sync
 * route takes image/jpeg and image/png and refuses any other (`15` section
 * 3.15a), and a refused sync keeps the whole audit on the phone. So a photo
 * of any other type, such as HEIC, is drawn again as a JPEG when it is taken,
 * and one this browser cannot draw is refused then, while the arborist can
 * still take it again, rather than at the sync.
 */

export const SENDABLE: readonly string[] = ["image/jpeg", "image/png"];

/* High enough that a redrawn photo keeps the detail an arborist photographs
 * a tree for; a camera's own JPEG is kept as it is and never redrawn. */
const JPEG_QUALITY = 0.9;

/* `redraw` is the browser's own, and a test's. */
export async function sendable(photo: Blob, redraw: (photo: Blob) => Promise<Blob> = asJpeg): Promise<Blob> {
  if (SENDABLE.includes(photo.type)) return photo;
  try {
    return await redraw(photo);
  } catch {
    throw new Error(`this phone could not convert a ${photo.type || "photo of an unknown type"} to one Arborcision takes`);
  }
}

async function asJpeg(photo: Blob): Promise<Blob> {
  const bitmap = await createImageBitmap(photo);
  const canvas = document.createElement("canvas");
  canvas.width = bitmap.width;
  canvas.height = bitmap.height;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("no canvas to draw the photo on");
  context.drawImage(bitmap, 0, 0);
  bitmap.close();
  return new Promise((resolve, reject) =>
    canvas.toBlob((jpeg) => (jpeg ? resolve(jpeg) : reject(new Error("no JPEG was drawn"))), "image/jpeg", JPEG_QUALITY),
  );
}
